/**
 * FAQ Page
 *
 * Content lives in data/content/faq.ts (#2212 — shared with the native
 * FAQ screen).
 */

import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { FAQ_DOC } from '../data/content/faq';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { MARKETING_PAGE_META } from '../lib/seo/pageMeta';

export default function FaqPage() {
  useDocumentTitle(MARKETING_PAGE_META['/faq'].title, { suffix: false });
  return (
    <PageLayout maxWidth="standard" title="FAQ">
      <ContentDocView doc={FAQ_DOC} />
    </PageLayout>
  );
}
